import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { EditorInput, EditorInputProps } from "./editor-input";

/**
 * EditorCard is a convenience abstraction to cover the common use
 * case of the Editor being used to handle a special text field.
 * It contains common editing options and a title and description
 * to explain the purpose of the field.
 * It expects an initial HTML value and returns updated HTML through
 * the onHtmlChange callback.
 */
export function EditorCard({
  title = t("Bemerkung"),
  description,
  ...props
}: EditorInputProps & {
  title?: string;
  description?: string;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <EditorInput {...props} />
      </CardContent>
    </Card>
  );
}
